<mat-form-field [class.is-fixed-width]="isFixedWidth" [class.multi-line-select]="allowMultiLine">
  <mat-select
    #multiSelect
    [ngModel]="multiCtrl.value"
    (valueChange)="onSelectionChange($event)"
    [placeholder]="(isLoading$ | async) ? 'Loading...' : placeholder"
    [multiple]="true"
    [compareWith]="compareFunction"
    [errorStateMatcher]="errorLabel !== undefined ? alwaysError : undefined"
    [disabled]="multiCtrl.disabled || (isLoading$ | async)"
    (closed)="propagateTouch()"
    [attr.data-testid]="testId"
  >
    <mat-select-trigger>
      {{ setSelectorTrigger }}
    </mat-select-trigger>
    <ng-container *ngIf="filteredOptions$ | async as filteredOptions">
      <mat-option>
        <ngx-mat-select-search
          [formControl]="multiFilterCtrl"
          [noEntriesFoundLabel]="filterNoEntriesFoundLabel"
          [placeholderLabel]="(isLoading$ | async) ? 'Loading...' : filterPlaceholderLabel"
          data-testid="multi-select-search-input"
        >
          <svg-icon ngxMatSelectSearchClear key="cancel"></svg-icon>
        </ngx-mat-select-search>
      </mat-option>
      <ng-container *ngIf="filteredOptions.length">
        <mat-option
          *ngFor="let option of options"
          [value]="option"
          [class.d-none]="!filteredOptions.includes(option)"
          [attr.data-testid]="testId + '-option-' + option.label"
        >
          {{ option.label }}
        </mat-option>
      </ng-container>
    </ng-container>
  </mat-select>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-error *ngIf="errorLabel !== undefined">{{ errorLabel }}</mat-error>
  <mat-hint *ngIf="hintLabel">{{ hintLabel }}</mat-hint>
  <mat-spinner diameter="25" *ngIf="isLoading$ | async"></mat-spinner>
</mat-form-field>
